import { createAction } from '@reduxjs/toolkit';
import { IChangePayload, ISubscriptionPlan, IUpdateCreatorSubscriptionPaymentPayload, types } from './types';
import { IErrorAction } from 'hls.js';
import type {
    CreatorGrantPaymentSource,
    ICreatorGrantablePlan,
    IGrantCreatorSubscriptionPayload,
    IGrantCreatorSubscriptionResult,
} from '../../types/global/creatorSubscription.types';
import type { IErrorType } from '../../constants/types';

export const setSubscription = () => ({
    type: types.SET_SUBSCRIPTION,
});

export const setSubscriptionSuccess = (payload: any) => ({
    type: types.SET_SUBSCRIPTION_SUCCESS,
    payload,
});

export const setSubscriptionFail = (payload: any) => ({
    type: types.SET_SUBSCRIPTION_FAIL,
    error: payload,
});

/** Subscription Action, takes an Object of two keys `Plan`, being the subscription plan, and `Authorization`
 * being the ID of the Credit card authorization
 */
export const subscribe = createAction<IChangePayload>(types.SUBSCRIBE);
export const subscribeSuccess = createAction<ISubscriptionPlan>(types.SUBSCRIBE_SUCCESS);
export const subscribeFail = createAction<IErrorAction>(types.SUBSCRIBE_FAIL);

export const getSubscriptionPlans = () => ({
    type: types.GET_SUBSCRIPTION_PLANS,
});

export const getSubscriptionPlansSuccess = (payload: any) => ({
    type: types.GET_SUBSCRIPTION_PLANS_SUCCESS,
    payload,
});

export const getSubscriptionPlansFail = (payload: any) => ({
    type: types.GET_SUBSCRIPTION_PLANS_FAIL,
    error: payload,
});

export const cancelSubsciption = (payload: any) => ({
    type: types.CANCEL_SUBSCRIPTION,
    payload,
});

export const cancelSubsciptionSuccess = (payload: any) => ({
    type: types.CANCEL_SUBSCRIPTION_SUCCESS,
    payload,
});

export const cancelSubsciptionFail = (payload: any) => ({
    type: types.CANCEL_SUBSCRIPTION_FAIL,
    error: payload,
});

export const updateSubscription = (payload: IUpdateCreatorSubscriptionPaymentPayload) => ({
    type: types.UPDATE_SUBSCRIPTION,
    payload,
});

export const updateSubscriptionSuccess = (payload: any) => ({
    type: types.UPDATE_SUBSCRIPTION_SUCCESS,
    payload,
});

export const updateSubscriptionFail = (payload: any) => ({
    type: types.UPDATE_SUBSCRIPTION_FAIL,
    error: payload,
});

export const activateCreatorSubscription = (subscriptionId: string) => ({
    type: types.ACTIVATE_CREATOR_SUBSCRIPTION,
    payload: subscriptionId,
});

export const activateCreatorSubscriptionSuccess = (payload: any) => ({
    type: types.ACTIVATE_CREATOR_SUBSCRIPTION_SUCCESS,
    payload,
});

export const activateCreatorSubscriptionFail = (payload: any) => ({
    type: types.ACTIVATE_CREATOR_SUBSCRIPTION_FAIL,
    error: payload,
});
export const resetSubscriptionData = () => ({
    type: types.RESET_SUBSCRIPTION_DATA,
});

export const initializePaystackSubscription = (payload: {
    plan: string;
    callback_url?: string;
    start_trial?: boolean;
    payment_method_id?: string;
    paymentMethodId?: string;
}) => ({
    type: types.INITIALIZE_PAYSTACK_SUBSCRIPTION,
    payload,
});

export const verifyPaystackSubscription = (payload: { reference: string }) => ({
    type: types.VERIFY_PAYSTACK_SUBSCRIPTION,
    payload,
});

export const initializeFlutterwaveSubscription = (payload: {
    plan: string;
    callback_url?: string;
    start_trial?: boolean;
    payment_method_id?: string;
    paymentMethodId?: string;
}) => ({
    type: types.INITIALIZE_FLUTTERWAVE_SUBSCRIPTION,
    payload,
});

export const verifyFlutterwaveSubscription = (payload: {
    transaction_id?: string;
    tx_ref?: string;
    reference?: string;
}) => ({
    type: types.VERIFY_FLUTTERWAVE_SUBSCRIPTION,
    payload,
});

export const fetchAdminCreatorGrantPlans = createAction<{
    source: CreatorGrantPaymentSource;
    /** Stripe only — matches GET /plan/stripe (Global for US/EU settings). */
    region?: string;
}>(types.FETCH_ADMIN_CREATOR_GRANT_PLANS);
export const fetchAdminCreatorGrantPlansSuccess = createAction<ICreatorGrantablePlan[]>(
    types.FETCH_ADMIN_CREATOR_GRANT_PLANS_SUCCESS,
);
export const fetchAdminCreatorGrantPlansFail = createAction<IErrorType>(types.FETCH_ADMIN_CREATOR_GRANT_PLANS_FAIL);

export const grantCreatorSubscriptionAdmin = createAction<IGrantCreatorSubscriptionPayload>(
    types.GRANT_CREATOR_SUBSCRIPTION_ADMIN,
);
export const grantCreatorSubscriptionAdminSuccess = createAction<IGrantCreatorSubscriptionResult>(
    types.GRANT_CREATOR_SUBSCRIPTION_ADMIN_SUCCESS,
);
export const grantCreatorSubscriptionAdminFail = createAction<IErrorType>(types.GRANT_CREATOR_SUBSCRIPTION_ADMIN_FAIL);

export const clearAdminCreatorGrant = createAction(types.CLEAR_ADMIN_CREATOR_GRANT);
